import { render, staticRenderFns } from "./expediente-modificaciones-formulario.vue?vue&type=template&id=5f5000ac&scoped=true&"
import script from "./expediente-modificaciones-formulario.vue?vue&type=script&lang=js&"
export * from "./expediente-modificaciones-formulario.vue?vue&type=script&lang=js&"
import style0 from "./expediente-modificaciones-formulario.vue?vue&type=style&index=0&id=5f5000ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5000ac",
  null
  
)

export default component.exports